import React from "react";

import withStyles from "material-ui/styles/withStyles";
import RegisterForm from "./Sections/RegisterForm";

import Parallax from "components/Parallax/Parallax.jsx";

import GridContainerHome from "components/Grid/GridContainerHome.jsx";
import GridItemHome from "components/Grid/GridItemHome.jsx";
import Card from "components/Card/Card.jsx";

import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";


class ProjectJoinPage extends React.Component {
  render() {
    const { classes, history } = this.props;
    return (
      <div>
        <Parallax image={require("assets/img/bg8.jpg")}>
          <div className={classes.container}>
          <GridContainerHome justify="center">
                <GridItemHome xs={12} sm={12} md={5}>
                  <div className={classes.brand}>
                      <h1 className={classes.title}>Join me</h1>
                        <div className={classes.subtitle}>
                          <h5>
                            Are you a <strong>Web/Mobile Developer</strong> or working on a framework relevant to JavaScript?
                          </h5>
                          <h5>
                            Are you a <strong>UI/UX Designer?</strong>
                          </h5>
                          <h5>
                            Are you a <strong>text writer, Sales & Marketing Expert or E-Commerce Developer?</strong>
                          </h5>
                          <br/>
                          <h5>
                            <strong>Let's build something awesome together and join me.</strong>
                          </h5>
                        </div>
                    </div>
                    </GridItemHome>
                      <GridItemHome xs={12} sm={12} md={5}>
                        <Card>
                          <RegisterForm history={history} />
                        </Card>
                    </GridItemHome>
                </GridContainerHome>
          </div>
        </Parallax>
      </div>
    );
  }
}

export default withStyles(componentsStyle)(ProjectJoinPage);



// WEBPACK FOOTER //
// ./src/views/ProjectJoinPage/ProjectJoinPage.jsx